import { Outlet } from '@remix-run/react'

import AboutClubSection from '#app/routes/_index+/components/AboutClubSection.tsx'
import Footer from '#app/routes/_index+/components/Footer.tsx'
import NavbarLanding from '#app/routes/_index+/components/NavbarLanding.tsx'

export default function NovidadesLayout() {
  return (
    <div className="app-landing-page novidades-subpage bg-white min-vh-100">
      <NavbarLanding variant="light" />
      <Outlet />
      <AboutClubSection />
      <Footer />
    </div>
  )
}
